export default {
    AGENDA_VIEW_STORE: {
        LOAD_AROUND_PIVOT: 'loadAroundPivot',
        LOAD_AROUND_PIVOT_RESPONSE: 'loadAroundPivotResponse',
        LOAD_ON_SCROLL: 'loadOnScroll',
        LOAD_ON_SCROLL_RESPONSE: 'loadOnScrollResponse',
        AGENDA_ITEMS_CONVERTED: 'agendaItemsConverted',
        AGENDA_ITEM_DAY_EVENT_COUNT_INCONSISTENCY: 'agendaItemsDayEventCountInconsistent',
    },
};
